export const SKILLS = [
  { category: "Languages", items: ["TypeScript", "Python", "JavaScript", "SQL", "HTML/CSS"] },
  { category: "Frontend", items: ["React", "Next.js", "React Native", "TailwindCSS", "Vite"] },
  { category: "Backend", items: ["FastAPI", "Node.js", "PostgreSQL", "REST APIs"] },
  { category: "Tools", items: ["Git", "Docker", "Vercel", "GitHub", "Agile/Scrum"] },
];

export const WORK_EXPERIENCE = [
  {
    title: "Student Developer @ Dev Youngstown",
    date: "December 2022 - November 2023",
    responsibilities: [
      "Pave Routes LLC",
      "Participated in Agile development processes, including regular stand-ups and sprint planning.",
      "Implemented FastAPI’s ORM and models for efficient data handling and validation.",
      "Integrated Garmin API to enhance the application’s functionality.",
      "Utilized Git for version control, adhering to GitHub flow with feature branches, pull requests, and code reviews.",
      "Worked remotely, demonstrating effective communication and collaboration within a distributed team.",
      "Application that utilizes React Native.js, FastAPI, and PostgreSQL for development.",
    ],
  },
  {
    title: "Student Developer @ Dev Youngstown",
    date: "December 2022 - November 2023",
    responsibilities: [
      "PollyTech LLC",
      "Developed the “Trukem” application, incorporating FastAPI and PostgreSQL for backend functionality.",
      "Implemented Shopify API callbacks to ensure compliance with GDPR and CPRA data privacy regulations",
      "Collaborated with a remote team using Git and GitHub for version control and issue tracking.",
    ],
  },
  {
    title: "Student Developer @ Dev Youngstown",
    date: "December 2022 - November 2023",
    responsibilities: [
      "Code Youngstown",
      "Built and maintained the website framework for Code Youngstown using Next.js and TailwindCSS",
      "Managed the website’s directory and job listings, incorporating user feedback through GitHub issues.",
    ],
  },
  {
    title: "Student Developer @ Dev Youngstown",
    date: "December 2022 - November 2023",
    responsibilities: [
      "Promowar.tv",
      "Contract work for PromoWar, involved in developing a static site for hosting PromoWar’s streaming service",
      "Utilized Next.js and hosted the site on Vercel, managing codebase through Git and GitHub.",
    ],
  },
];

export const PROJECT_EXPERIENCE = [
  {
    title: "Personal Portfolio Website",
    date: "April 30, 2024 - Current",
    description: [
      "A full-stack website designed to showcase my skills, projects, and experience, including a portal for users to contact me.",
      "Key features: Professional Profile, Contact System, Responsive Design, and Authentication.",
      "Implemented a messaging system where users can contact me through a form. The messages are sent to my backend, allowing me to log into an Admin Portal to view them.",
      "Technologies: Vite, ReactJS, TypeScript, FastAPI, PostgreSQL.",
    ],
    link: "https://trongong.com/",
  },
  {
    title: "Galactic Defender",
    date: "March 13, 2024 - Current",
    description: [
      "A space shooter game designed to provide an entertaining experience where players aim to achieve high scores by destroying alien ships and avoiding being hit.",
      "Key features: Spaceship Controls, Bullet Mechanics, Alien Waves, Score Tracking, Particles and Effects, Background and Sound Effects.",
      "Technologies: Python (Pygame).",
    ],
    link: "https://github.com/TrongOng/galactic-defender",
  },
];
